// Instance
import MainAPI from "@/app/apis/main/main-api.js"

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js"

// Query String
const queryString = require("querystring")

class PaymentAPI extends MainAPI {
	/**
	 * @param petId
	 * @param paymentDetails
	 * @return No content
	 */
	async chargePayment(petId, paymentDetails) {
		return API.post(`${ENDPOINTS.POST_PAYMENT_CHARGE}/${petId}`, paymentDetails)
	}

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async lattitudePayment(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_PAYMENT_LATITUDE}`, paymentDetails)
	}

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async updateStatusLatitudePay(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_UPDATE_PAYMENT_LATITUDE}`, paymentDetails)
	}

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async latitudePaymentPublic(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_PUBLIC_PAYMENT_LATITUDE}`, paymentDetails)
	}

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async updateStatusLatitude(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_UPDATE_STATUS_LATITUDE}`, paymentDetails)
	}

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async proceedToLatitude(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_CHECKOUT_LATITUDE}`, paymentDetails)
	}

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async proceedToLatitudeInterestFree(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_CHECKOUT_LATITUDE_INTEREST_FREE}`, paymentDetails)
	}

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async proceedProductToLatitudeInterestFree(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_PRODUCT_CHECKOUT_LATITUDE_INTEREST_FREE}`, paymentDetails)
	}

	/**
	 * @param paymentDetails
	 * @return {object}
	 */
	async verifyLatitude(paymentDetails) {
		return API.post(`${ENDPOINTS.POST_VERIFY_LATITUDE}`, paymentDetails)
	}

	async getLatitudeInterestFreeUrl(orderId) {
		return API.get(`${ENDPOINTS.GET_LATITUDE_INTEREST_FREE}/retrieve/url/${orderId}`)
	}

	async getLatitudeInterestFreeUrlForProductPurchase(puppyPurchaseId) {
		return API.get(`${ENDPOINTS.GET_LATITUDE_INTEREST_FREE}/retrieve/puppy-purchase/url/${puppyPurchaseId}`)
	}

	async getLatitudeInterestFreeUrlForProductPurchasePublic(queryParams) {
		return API.get(`${ENDPOINTS.GET_LATITUDE_INTEREST_FREE}/retrieve/puppy-purchase/public/url?${queryString.stringify(queryParams)}`)
	}

}

export default new PaymentAPI()
